import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Раздел содержит настройки программы.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Общие настройки системы – настройка разделения веса на \"нетто\" и \"брутто\", выбор типа отклонения веса груза (процент или вес)"),
  /*#__PURE__*/_createElementVNode("li", null, "Настройки отчетов – настройки отображения на схеме вида сзади, разрезов и ярусов, настройка построения схемы на правую и левую сторону"),
  /*#__PURE__*/_createElementVNode("li", null, "Настройки схем – настройка отображения частот диаметров, выбор вида рисования (лейбл, наименование, формат или лейбл и формат), выбор стороны двери (правая или левая)"),
  /*#__PURE__*/_createElementVNode("li", null, "Настройки планов – настройка отображения единой таблицы для грузов, настройки отображения на схеме вида сзади, разрезов и ярусов, настройка погрузки рулонов вторым ярусом, выбор высоты перекрытия ярусов, выбор максимальной разницы в весе между ТС"),
  /*#__PURE__*/_createElementVNode("li", null, "Настройки импорта и экспорта – выбор нормативного отступа и нормативного смещения в транспорте")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Настройки программы",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}